import React, { useState } from 'react';

function PhoneAuth({ country, onSubmit, onBack }) {
  const [phoneNumber, setPhoneNumber] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (phoneNumber.trim()) {
      onSubmit(country.dialCode + phoneNumber);
    }
  };

  return (
    <div className="screen-container">
      <button className="back-button" onClick={onBack}>←</button>
      
      <div className="content-card">
        <div className="logo-container">
          <div className="logo">H</div>
          <div className="logo-text">Homie</div>
          <p className="tagline">Track all your shippings in one place</p>
        </div>
        
        <p className="subtitle">
          Enter your phone number to receive a verification code
        </p>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Phone Number</label>
            <div className="phone-input-container">
              <div className="country-code-display">
                {country.flag} {country.dialCode}
              </div>
              <input
                type="tel"
                className="phone-input"
                placeholder="123 456 7890"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                required
              />
            </div>
          </div>
          
          <button 
            type="submit" 
            className="submit-button"
            disabled={!phoneNumber.trim()}
          >
            Send Code
          </button>
        </form>
      </div>
    </div>
  );
}

export default PhoneAuth;
